import { callApi } from "./ApiClient";

const login = (loginInfo, dispatch) => {
  return callApi("POST", "/login", loginInfo, dispatch);
};

const logout = (dispatch) => {
  return callApi("POST", "/logout", {}, dispatch);
};

const resetPassword = (newPasswordInfo, dispatch) => {
  return callApi("POST", "/password/reset", newPasswordInfo, dispatch);
};

const requestPassword = (requestInfo, dispatch) => {
  return callApi("POST", "/password/request", requestInfo, dispatch);
};

const signup = (signupInfo, dispatch) => {
  return callApi("POST", "/users", signupInfo, dispatch);
};

const getUser = (dispatch) => {
  return callApi("GET", "/users/me", null, dispatch);
};

const deleteUser = (dispatch) => {
  return callApi("DELETE", "/users/me", null, dispatch);
};

const patchUser = (data, dispatch) => {
  return callApi("PATCH", "/users/me", data, dispatch);
};

const putUsersMePayment = (data, dispatch) => {
  return callApi("PUT", "/users/me/payments", data, dispatch);
};

const postUsersMePayment = (data, dispatch) => {
  return callApi("POST", "/users/me/payments", data, dispatch);
};

const postUsersMePlans = (data, dispatch) => {
  return callApi("POST", "/users/me/plans", data, dispatch);
};

const postUsersUpdatePassword = (data, dispatch) => {
  return callApi("POST", "/users/me/update-password", data, dispatch);
};

const getPasswordSecurityQuestion = (data, dispatch) => {
  return callApi("GET", "/password/security-question", data, dispatch);
};

const getChildUsers = (data, dispatch) => {
  return callApi("GET", "/users/child-accounts", data, dispatch);
}

const getChildUserById = (id, dispatch) => {
  return callApi("GET", `/users/child-accounts/${id}`, null, dispatch)
}

const postChildUser = (data, dispatch) => {
  return callApi('POST', `/users/child-accounts`, data, dispatch);
}

const putChildUsersAuthority = (data, dispatch) => {
  return callApi('PUT', `/users/child-accounts/authority`, data, dispatch);
}

const patchChildUserAuthorityById = (id, data, dispatch) => {
  return callApi('PATCH', `/users/child-accounts/authority/${id}`, data, dispatch);
}

const deleteChildUser = (id, dispatch) => {
  return callApi("DELETE", `/users/child-accounts/${id}`, null, dispatch);
};

const getProxyLoginChildUser = (id, dispatch) => {
  return callApi("GET", `/users/child-accounts/proxy_login/${id}`, null, dispatch);
};

const getProxyLoginParentUser = (dispatch) => {
  return callApi("GET", `/users/parent-account/proxy_login`, null, dispatch);
};

export const UsersApi = {
  login,
  logout,
  signup,
  resetPassword,
  requestPassword,
  getUser,
  deleteUser,
  patchUser,
  putUsersMePayment,
  postUsersMePayment,
  postUsersMePlans,
  postUsersUpdatePassword,
  getPasswordSecurityQuestion,
  getChildUsers,
  getChildUserById,
  postChildUser,
  putChildUsersAuthority,
  patchChildUserAuthorityById,
  deleteChildUser,
  getProxyLoginChildUser,
  getProxyLoginParentUser,
};



// WEBPACK FOOTER //
// ./src/redux/api/UsersApi.js